"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaLibrarySettingConfig = exports.advancedSelectConfig = exports.colorSettingConfig = exports.textSettingConfig = exports.numberRangeSettingConfig = exports.decimalSettingConfig = exports.numberSettingConfig = exports.commonFieldsConfig = exports.copyFieldsToSetting = exports.recreateSettingInstance = exports.extractFieldsFromSetting = exports.getTypeString = exports.convertSettingToBackendFormat = exports.createSettingFromData = exports.availableSettings = void 0;
var q_play_core_1 = require("@nordicscreen/q-play-core");
var FieldsComponent_1 = require("../Components/Developer/FieldsComponent");
var AppEditor_module_css_1 = __importDefault(require("../Components/Developer/AppEditor/AppEditor.module.css"));
exports.availableSettings = [
    (function () {
        var s = new q_play_core_1.StringSetting("customString", "Custom String");
        s.defaultValue = "Default text";
        s.description = "A custom string setting.";
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.BooleanSetting("customBoolean", "Custom Boolean");
        s.defaultValue = false;
        s.description = "A custom boolean setting.";
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.SelectSetting("customSelect", "Custom Select");
        s.options = [
            { label: "Option 1", value: "option1" },
            { label: "Option 2", value: "option2" },
        ];
        s.defaultValue = "option1";
        s.description = "Choose an option.";
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.DecimalSetting("customDecimal", "Custom Decimal");
        s.defaultValue = 10.5;
        s.description = "A decimal value setting.";
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.IntegerSetting("customInteger", "Custom Integer");
        s.defaultValue = 42;
        s.description = "An integer value setting.";
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.TextSetting("customText", "Custom Text");
        s.defaultValue = "Some long text...";
        s.description = "A multiline text setting.";
        s.cols = 30;
        s.rows = 3;
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.PasswordSetting("customPassword", "Custom Password");
        s.defaultValue = "";
        s.description = "A password setting.";
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.NumberRangeSetting("customRange", "Custom Range");
        s.defaultValue = 50;
        s.description = "A range setting from 0 to 100.";
        s.minValue = 0;
        s.maxValue = 100;
        s.step = 1;
        s.showInputField = true;
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.ColorSetting("customColor", "Custom Color");
        s.defaultValue = "#000000";
        s.description = "A color picker setting.";
        s.placement = "bottom";
        s.hideColorPalette = false;
        s.hideAlpha = false;
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.AdvancedSelectSetting("customAdvancedSelect", "Custom Advanced Select");
        s.defaultValue = { label: "Option 1", value: "option1" };
        s.description = "An advanced select setting.";
        s.option_object = {
            value_property: "value",
            label_property: "label",
            options: [
                { label: "Option 1", value: "option1" },
                { label: "Option 2", value: "option2" }
            ],
            url: "",
            search_param: "",
            response_data: "",
            should_fetch_on_load: false,
            should_throttle_request: false,
            should_use_local_filter: true
        };
        s.placeholder = "Select an option";
        s.no_option_text = "No options available";
        return s;
    })(),
    (function () {
        var s = new q_play_core_1.MediaLibrarySetting("customMediaLibrary", "Custom Media Library");
        s.defaultValue = null;
        s.description = "A media library setting for file uploads.";
        s.mimeGroup = "";
        s.origin = process.env.APP_URL || "";
        s.url = null;
        s.thumbnailUrl = null;
        s.fileName = null;
        return s;
    })(),
];
/**
 * Convert raw setting data to a Q-Play Setting instance.
 */
function createSettingFromData(key, data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var normalizedType = data.type;
    var compatibleData = __assign({}, data);
    if (data.defaultValue !== undefined && data.default === undefined) {
        compatibleData.default = data.defaultValue;
    }
    if (data.minValue !== undefined && data.min === undefined) {
        compatibleData.min = data.minValue;
    }
    if (data.maxValue !== undefined && data.max === undefined) {
        compatibleData.max = data.maxValue;
    }
    if (data.showInputField !== undefined && data.show_input_field === undefined) {
        compatibleData.show_input_field = data.showInputField;
    }
    if (data.queryParams !== undefined && data.query_params === undefined) {
        compatibleData.query_params = data.queryParams;
    }
    if (data.hideColorPalette !== undefined && data.hide_color_palette === undefined) {
        compatibleData.hide_color_palette = data.hideColorPalette;
    }
    if (data.hideAlpha !== undefined && data.hide_alpha === undefined) {
        compatibleData.hide_alpha = data.hideAlpha;
    }
    var setting = q_play_core_1.Setting.createSettingFromData(key, __assign(__assign({}, compatibleData), { type: normalizedType }));
    if (!setting) {
        return undefined;
    }
    setting.key = key;
    setting.label = compatibleData.label || "";
    setting.section = compatibleData.section || "";
    setting.visible = (_a = compatibleData.visible) !== null && _a !== void 0 ? _a : true;
    setting.fixed = (_b = compatibleData.fixed) !== null && _b !== void 0 ? _b : false;
    setting.required = (_c = compatibleData.required) !== null && _c !== void 0 ? _c : false;
    setting.description = compatibleData.description || "";
    setting.secret = (_d = compatibleData.secret) !== null && _d !== void 0 ? _d : false;
    setting.order = (_e = compatibleData.order) !== null && _e !== void 0 ? _e : 100;
    setting.defaultValue = (_f = compatibleData.default) !== null && _f !== void 0 ? _f : setting.defaultValue;
    setting.layout = compatibleData.layout || "default";
    setting.alignment = compatibleData.alignment || "left";
    setting.conditions = compatibleData.conditions || [];
    setting.debounce = (_g = compatibleData.debounce) !== null && _g !== void 0 ? _g : false;
    setting.disabled = (_h = compatibleData.disabled) !== null && _h !== void 0 ? _h : false;
    setting.readonly = (_j = compatibleData.readonly) !== null && _j !== void 0 ? _j : false;
    setting.metadata = compatibleData.metadata || "";
    if (setting instanceof q_play_core_1.NumberSetting) {
        setting.minValue = (_k = compatibleData.min) !== null && _k !== void 0 ? _k : null;
        setting.maxValue = (_l = compatibleData.max) !== null && _l !== void 0 ? _l : null;
        setting.step = (_m = compatibleData.step) !== null && _m !== void 0 ? _m : null;
    }
    if (setting instanceof q_play_core_1.IntegerSetting) {
        setting.defaultValue =
            typeof compatibleData.default === "number" && Number.isInteger(compatibleData.default)
                ? compatibleData.default
                : setting.defaultValue || 0;
    }
    if (setting instanceof q_play_core_1.NumberRangeSetting) {
        setting.showInputField = (_o = compatibleData.show_input_field) !== null && _o !== void 0 ? _o : false;
    }
    if (setting instanceof q_play_core_1.SelectSetting) {
        setting.options = compatibleData.options || [];
    }
    if (setting instanceof q_play_core_1.StringSetting &&
        !(setting instanceof q_play_core_1.TextSetting) &&
        !(setting instanceof q_play_core_1.SelectSetting) &&
        !(setting instanceof q_play_core_1.PasswordSetting)) {
        setting.queryParams = compatibleData.query_params || [];
    }
    if (setting instanceof q_play_core_1.TextSetting) {
        setting.cols = (_p = compatibleData.cols) !== null && _p !== void 0 ? _p : 20;
        setting.rows = (_q = compatibleData.rows) !== null && _q !== void 0 ? _q : 2;
    }
    if (setting instanceof q_play_core_1.ColorSetting) {
        setting.placement = compatibleData.placement || "auto";
        setting.hideColorPalette = (_r = compatibleData.hide_color_palette) !== null && _r !== void 0 ? _r : false;
        setting.hideAlpha = (_s = compatibleData.hide_alpha) !== null && _s !== void 0 ? _s : false;
    }
    if (setting instanceof q_play_core_1.AdvancedSelectSetting) {
        var defaultVal = (_t = compatibleData.default) !== null && _t !== void 0 ? _t : compatibleData.default;
        if (typeof defaultVal === "object" &&
            defaultVal !== null &&
            "label" in defaultVal &&
            "value" in defaultVal &&
            typeof defaultVal.label === "string" &&
            typeof defaultVal.value === "string") {
            setting.defaultValue = defaultVal;
        }
        else {
            setting.defaultValue = { label: "", value: "" };
        }
        setting.placeholder = compatibleData.placeholder || "";
        setting.no_option_text = compatibleData.no_option_text || "";
        setting.option_object = compatibleData.option_object || {
            value_property: "",
            label_property: "",
            options: [],
            url: undefined,
            search_param: undefined,
            response_data: undefined,
            should_fetch_on_load: false,
            should_throttle_request: false,
            should_use_local_filter: true,
        };
    }
    if (setting instanceof q_play_core_1.MediaLibrarySetting) {
        setting.mimeGroup = data.mime_group || "";
        setting.origin = data.origin || process.env.APP_URL || "";
        var hasAll = data.url && data.file_name;
        if (hasAll) {
            var hydrated = {
                url: data.url,
                thumbnailUrl: (_u = data.thumbnail_url) !== null && _u !== void 0 ? _u : null,
                file_name: data.file_name
            };
            setting.hydrate(hydrated);
            setting.defaultValue = hydrated;
        }
    }
    return setting;
}
exports.createSettingFromData = createSettingFromData;
/**
 * Convert a Q-Play Setting instance to the shape your backend expects.
 */
function convertSettingToBackendFormat(setting) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var formattedWithDuplicates = {
        key: setting.key,
        type: getTypeString(setting),
        label: setting.label,
        section: setting.section === "" ? null : setting.section,
        visible: setting.visible,
        fixed: setting.fixed,
        required: setting.required,
        description: setting.description || "",
        secret: setting.secret,
        order: setting.order || 100,
        default: setting.defaultValue,
        layout: setting.layout || "default",
        alignment: setting.alignment || "left",
        conditions: setting.conditions,
        debounce: setting.debounce,
        disabled: setting.disabled,
        readonly: setting.readonly,
        metadata: setting.metadata || "",
        defaultValue: setting.defaultValue,
    };
    delete formattedWithDuplicates.defaultValue;
    if (setting instanceof q_play_core_1.NumberSetting) {
        formattedWithDuplicates.min = (_a = setting.minValue) !== null && _a !== void 0 ? _a : null;
        formattedWithDuplicates.max = (_b = setting.maxValue) !== null && _b !== void 0 ? _b : null;
        formattedWithDuplicates.minValue = (_c = setting.minValue) !== null && _c !== void 0 ? _c : null;
        formattedWithDuplicates.maxValue = (_d = setting.maxValue) !== null && _d !== void 0 ? _d : null;
        delete formattedWithDuplicates.minValue;
        delete formattedWithDuplicates.maxValue;
    }
    if (setting instanceof q_play_core_1.DecimalSetting) {
        formattedWithDuplicates.decimals = (_e = setting.decimals) !== null && _e !== void 0 ? _e : null;
    }
    if (setting instanceof q_play_core_1.NumberRangeSetting) {
        formattedWithDuplicates.showInputField = setting.showInputField;
        delete formattedWithDuplicates.showInputField;
    }
    if (setting instanceof q_play_core_1.SelectSetting) {
        formattedWithDuplicates.options = setting.options || [];
    }
    if (setting instanceof q_play_core_1.TextSetting) {
        formattedWithDuplicates.cols = setting.cols;
        formattedWithDuplicates.rows = setting.rows;
    }
    if (setting instanceof q_play_core_1.StringSetting &&
        !(setting instanceof q_play_core_1.TextSetting) &&
        !(setting instanceof q_play_core_1.SelectSetting) &&
        !(setting instanceof q_play_core_1.PasswordSetting)) {
        formattedWithDuplicates.query_params = setting.queryParams || [];
        delete formattedWithDuplicates.queryParams;
    }
    if (setting instanceof q_play_core_1.ColorSetting) {
        formattedWithDuplicates.placement = setting.placement;
        formattedWithDuplicates.hide_color_palette = setting.hideColorPalette;
        formattedWithDuplicates.hide_alpha = setting.hideAlpha;
        delete formattedWithDuplicates.hideColorPalette;
        delete formattedWithDuplicates.hideAlpha;
    }
    if (setting instanceof q_play_core_1.AdvancedSelectSetting) {
        formattedWithDuplicates.placeholder = setting.placeholder || "";
        formattedWithDuplicates.no_option_text = setting.no_option_text || "";
        formattedWithDuplicates.option_object = __assign(__assign(__assign(__assign({ value_property: ((_f = setting.option_object) === null || _f === void 0 ? void 0 : _f.value_property) || "value", label_property: ((_g = setting.option_object) === null || _g === void 0 ? void 0 : _g.label_property) || "label", options: ((_h = setting.option_object) === null || _h === void 0 ? void 0 : _h.options) || [] }, (((_j = setting.option_object) === null || _j === void 0 ? void 0 : _j.url) &&
            setting.option_object.url.trim() !== "" && { url: setting.option_object.url })), (((_k = setting.option_object) === null || _k === void 0 ? void 0 : _k.search_param) &&
            setting.option_object.search_param.trim() !== "" && {
            search_param: setting.option_object.search_param,
        })), (((_l = setting.option_object) === null || _l === void 0 ? void 0 : _l.response_data) &&
            setting.option_object.response_data.trim() !== "" && {
            response_data: setting.option_object.response_data,
        })), { should_fetch_on_load: (_o = (_m = setting.option_object) === null || _m === void 0 ? void 0 : _m.should_fetch_on_load) !== null && _o !== void 0 ? _o : false, should_throttle_request: (_q = (_p = setting.option_object) === null || _p === void 0 ? void 0 : _p.should_throttle_request) !== null && _q !== void 0 ? _q : false, should_use_local_filter: (_s = (_r = setting.option_object) === null || _r === void 0 ? void 0 : _r.should_use_local_filter) !== null && _s !== void 0 ? _s : true });
    }
    if (setting instanceof q_play_core_1.MediaLibrarySetting) {
        formattedWithDuplicates.type = "media_library";
        formattedWithDuplicates.mime_group = setting.mimeGroup;
        formattedWithDuplicates.origin = process.env.APP_URL || "";
        formattedWithDuplicates.url = setting.url;
        formattedWithDuplicates.thumbnail_url = setting.thumbnailUrl;
        formattedWithDuplicates.file_name = setting.fileName;
        formattedWithDuplicates.default = setting.defaultValue;
    }
    return formattedWithDuplicates;
}
exports.convertSettingToBackendFormat = convertSettingToBackendFormat;
/**
 * Determine the "type" string for the setting (used in backend).
 */
function getTypeString(setting) {
    if (setting instanceof q_play_core_1.PasswordSetting)
        return "password";
    if (setting instanceof q_play_core_1.TextSetting)
        return "text";
    if (setting instanceof q_play_core_1.SelectSetting)
        return "select";
    if (setting instanceof q_play_core_1.ColorSetting)
        return "color";
    if (setting instanceof q_play_core_1.DecimalSetting)
        return "decimal";
    if (setting instanceof q_play_core_1.IntegerSetting)
        return "integer";
    if (setting instanceof q_play_core_1.NumberRangeSetting)
        return "range";
    if (setting instanceof q_play_core_1.NumberSetting)
        return "number";
    if (setting instanceof q_play_core_1.StringSetting)
        return "string";
    if (setting instanceof q_play_core_1.BooleanSetting)
        return "boolean";
    if (setting instanceof q_play_core_1.AdvancedSelectSetting)
        return "advanced_select";
    if (setting instanceof q_play_core_1.MediaLibrarySetting)
        return "media_library";
    return "string";
}
exports.getTypeString = getTypeString;
/**
 * Extract editable fields from a Q-Play Setting instance into a plain object.
 */
function extractFieldsFromSetting(setting) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    var fields = {
        key: setting.key,
        label: setting.label,
        section: setting.section || "",
        visible: setting.visible,
        fixed: setting.fixed,
        required: setting.required,
        description: setting.description || "",
        secret: setting.secret,
        order: setting.order,
        default: (_a = setting.defaultValue) !== null && _a !== void 0 ? _a : "",
        layout: setting.layout,
        alignment: setting.alignment,
        conditions: setting.conditions,
        debounce: setting.debounce,
        disabled: setting.disabled,
        readonly: setting.readonly,
        metadata: setting.metadata || "",
    };
    if (setting instanceof q_play_core_1.NumberSetting ||
        setting instanceof q_play_core_1.NumberRangeSetting) {
        fields.minValue = (_b = setting.minValue) !== null && _b !== void 0 ? _b : null;
        fields.maxValue = (_c = setting.maxValue) !== null && _c !== void 0 ? _c : null;
        fields.step = (_d = setting.step) !== null && _d !== void 0 ? _d : null;
    }
    if (setting instanceof q_play_core_1.DecimalSetting) {
        fields.decimals = (_e = setting.decimals) !== null && _e !== void 0 ? _e : null;
    }
    if (setting instanceof q_play_core_1.NumberRangeSetting) {
        fields.showInputField = setting.showInputField;
    }
    if (setting instanceof q_play_core_1.SelectSetting) {
        fields.options = setting.options || [];
    }
    if (setting instanceof q_play_core_1.StringSetting &&
        !(setting instanceof q_play_core_1.TextSetting) &&
        !(setting instanceof q_play_core_1.SelectSetting) &&
        !(setting instanceof q_play_core_1.PasswordSetting)) {
        fields.query_params = setting.queryParams || [];
    }
    if (setting instanceof q_play_core_1.TextSetting) {
        fields.cols = setting.cols;
        fields.rows = setting.rows;
    }
    if (setting instanceof q_play_core_1.ColorSetting) {
        fields.placement = setting.placement || "auto";
        fields.hideColorPalette = (_f = setting.hideColorPalette) !== null && _f !== void 0 ? _f : false;
        fields.hideAlpha = (_g = setting.hideAlpha) !== null && _g !== void 0 ? _g : false;
        fields.default =
            typeof setting.defaultValue === "string" ? setting.defaultValue : "#000000";
    }
    if (setting instanceof q_play_core_1.AdvancedSelectSetting) {
        fields.placeholder = setting.placeholder;
        fields.no_option_text = setting.no_option_text;
        fields.value_property = ((_h = setting.option_object) === null || _h === void 0 ? void 0 : _h.value_property) || "value";
        fields.label_property = ((_j = setting.option_object) === null || _j === void 0 ? void 0 : _j.label_property) || "label";
        var rawOptions = (_l = (_k = setting.option_object) === null || _k === void 0 ? void 0 : _k.options) !== null && _l !== void 0 ? _l : [];
        fields.options = rawOptions;
        fields.url = ((_m = setting.option_object) === null || _m === void 0 ? void 0 : _m.url) || "";
        fields.search_param = ((_o = setting.option_object) === null || _o === void 0 ? void 0 : _o.search_param) || "";
        fields.response_data = ((_p = setting.option_object) === null || _p === void 0 ? void 0 : _p.response_data) || "";
        fields.should_fetch_on_load = (_r = (_q = setting.option_object) === null || _q === void 0 ? void 0 : _q.should_fetch_on_load) !== null && _r !== void 0 ? _r : false;
        fields.should_throttle_request = (_t = (_s = setting.option_object) === null || _s === void 0 ? void 0 : _s.should_throttle_request) !== null && _t !== void 0 ? _t : false;
        fields.should_use_local_filter = (_v = (_u = setting.option_object) === null || _u === void 0 ? void 0 : _u.should_use_local_filter) !== null && _v !== void 0 ? _v : true;
        if (setting.defaultValue &&
            typeof setting.defaultValue === "object" &&
            !Array.isArray(setting.defaultValue) &&
            "label" in setting.defaultValue &&
            "value" in setting.defaultValue) {
            fields.default = setting.defaultValue;
        }
        else {
            fields.default = { label: "", value: "" };
        }
    }
    if (setting instanceof q_play_core_1.MediaLibrarySetting) {
        fields.mime_group = setting.mimeGroup;
        fields.origin = setting.origin;
        fields.url = setting.url;
        fields.thumbnail_url = setting.thumbnailUrl;
        fields.file_name = setting.fileName;
        fields.default = setting.defaultValue;
    }
    return fields;
}
exports.extractFieldsFromSetting = extractFieldsFromSetting;
/**
 * Recreate a Q-Play Setting instance with the correct constructor based on type,
 * then apply base fields.
 */
function recreateSettingInstance(baseSetting, fields) {
    var _a, _b;
    var type = getTypeString(baseSetting);
    switch (type) {
        case "password":
            return new q_play_core_1.PasswordSetting(fields.key, fields.label);
        case "string":
            return new q_play_core_1.StringSetting(fields.key, fields.label);
        case "boolean":
            return new q_play_core_1.BooleanSetting(fields.key, fields.label);
        case "number":
            return new q_play_core_1.NumberSetting(fields.key, fields.label);
        case "integer":
            return new q_play_core_1.IntegerSetting(fields.key, fields.label);
        case "decimal":
            return new q_play_core_1.DecimalSetting(fields.key, fields.label);
        case "range": {
            var nr = new q_play_core_1.NumberRangeSetting(fields.key, fields.label);
            nr.minValue = fields.minValue;
            nr.maxValue = fields.maxValue;
            nr.step = fields.step;
            return nr;
        }
        case "select": {
            var sel = new q_play_core_1.SelectSetting(fields.key, fields.label);
            sel.options = fields.options || [];
            return sel;
        }
        case "text": {
            var txt = new q_play_core_1.TextSetting(fields.key, fields.label);
            txt.cols = fields.cols || 30;
            txt.rows = fields.rows || 3;
            return txt;
        }
        case "color": {
            var cs = new q_play_core_1.ColorSetting(fields.key, fields.label);
            cs.placement = fields.placement || "auto";
            cs.hideColorPalette = (_a = fields.hideColorPalette) !== null && _a !== void 0 ? _a : false;
            cs.hideAlpha = (_b = fields.hideAlpha) !== null && _b !== void 0 ? _b : false;
            return cs;
        }
        case "advanced_select": {
            var as = new q_play_core_1.AdvancedSelectSetting(fields.key, fields.label);
            as.placeholder = fields.placeholder || "";
            as.no_option_text = fields.no_option_text || "";
            return as;
        }
        case "media_library": {
            var ml = new q_play_core_1.MediaLibrarySetting(fields.key, fields.label);
            ml.mimeGroup = fields.mime_group || "";
            ml.origin = process.env.APP_URL || "";
            ml.url = fields.url || null;
            ml.thumbnailUrl = fields.thumbnail_url || null;
            ml.fileName = fields.file_name || null;
            return ml;
        }
        default:
            console.warn("Unhandled setting type: ".concat(type));
            return baseSetting;
    }
}
exports.recreateSettingInstance = recreateSettingInstance;
/**
 * Copy changed fields from the user's form back onto the Q-Play Setting object.
 */
function copyFieldsToSetting(setting, fields) {
    var _a, _b, _c, _d;
    setting.label = fields.label;
    setting.section = fields.section || undefined;
    setting.visible = !!fields.visible;
    setting.fixed = !!fields.fixed;
    setting.required = !!fields.required;
    setting.description = fields.description || undefined;
    setting.secret = !!fields.secret;
    setting.order = parseInt(((_a = fields.order) === null || _a === void 0 ? void 0 : _a.toString()) || "100", 10);
    setting.layout = fields.layout || "default";
    setting.alignment = fields.alignment || "left";
    setting.conditions = fields.conditions;
    setting.debounce = !!fields.debounce;
    setting.disabled = !!fields.disabled;
    setting.readonly = !!fields.readonly;
    setting.metadata = fields.metadata || undefined;
    setting.defaultValue = fields.default;
    if (setting instanceof q_play_core_1.NumberSetting) {
        setting.minValue = fields.minValue !== undefined && fields.minValue !== null
            ? parseFloat(fields.minValue.toString())
            : undefined;
        setting.maxValue = fields.maxValue !== undefined && fields.maxValue !== null
            ? parseFloat(fields.maxValue.toString())
            : undefined;
        setting.step = fields.step !== undefined && fields.step !== null
            ? parseFloat(fields.step.toString())
            : undefined;
    }
    if (setting instanceof q_play_core_1.DecimalSetting) {
        setting.decimals = fields.decimals !== undefined && fields.decimals !== null
            ? parseInt(fields.decimals.toString(), 10)
            : undefined;
    }
    if (setting instanceof q_play_core_1.NumberRangeSetting) {
        setting.showInputField = !!fields.showInputField;
    }
    if (setting instanceof q_play_core_1.SelectSetting) {
        setting.options = fields.options || [];
    }
    if (setting instanceof q_play_core_1.StringSetting &&
        !(setting instanceof q_play_core_1.TextSetting) &&
        !(setting instanceof q_play_core_1.SelectSetting) &&
        !(setting instanceof q_play_core_1.PasswordSetting)) {
        setting.queryParams = fields.query_params || [];
    }
    if (setting instanceof q_play_core_1.TextSetting) {
        setting.cols = fields.cols || 20;
        setting.rows = fields.rows || 2;
    }
    if (setting instanceof q_play_core_1.ColorSetting) {
        setting.placement = fields.placement || "auto";
        setting.hideColorPalette = !!fields.hideColorPalette;
        setting.hideAlpha = !!fields.hideAlpha;
    }
    if (setting instanceof q_play_core_1.AdvancedSelectSetting) {
        setting.placeholder = fields.placeholder || "";
        setting.no_option_text = fields.no_option_text || "";
        setting.option_object = __assign(__assign(__assign(__assign({ value_property: fields.value_property || "value", label_property: fields.label_property || "label", options: fields.options || [] }, (fields.url && { url: fields.url })), (fields.search_param && { search_param: fields.search_param })), (fields.response_data && { response_data: fields.response_data })), { should_fetch_on_load: (_b = fields.should_fetch_on_load) !== null && _b !== void 0 ? _b : false, should_throttle_request: (_c = fields.should_throttle_request) !== null && _c !== void 0 ? _c : false, should_use_local_filter: (_d = fields.should_use_local_filter) !== null && _d !== void 0 ? _d : true });
    }
    if (setting instanceof q_play_core_1.MediaLibrarySetting) {
        setting.mimeGroup = fields.mime_group || "";
        setting.origin = process.env.APP_URL || "";
        setting.url = fields.url || null;
        setting.thumbnailUrl = fields.thumbnail_url || null;
        setting.fileName = fields.file_name || null;
    }
    return setting;
}
exports.copyFieldsToSetting = copyFieldsToSetting;
/**
 * The Field Config arrays
 */
exports.commonFieldsConfig = [
    { field: "key", Component: FieldsComponent_1.TextField, type: "text", "data-cy": "settingKey" },
    { field: "label", Component: FieldsComponent_1.TextField, type: "text", "data-cy": "settingLabel" },
    { field: "section", Component: FieldsComponent_1.TextField, type: "text" },
    { field: "visible", Component: FieldsComponent_1.CheckboxField },
    { field: "fixed", Component: FieldsComponent_1.CheckboxField },
    { field: "required", Component: FieldsComponent_1.CheckboxField },
    { field: "description", Component: FieldsComponent_1.TextField, type: "text", "data-cy": "settingDescription" },
    { field: "secret", Component: FieldsComponent_1.CheckboxField },
    { field: "order", Component: FieldsComponent_1.TextField, type: "number" },
    { field: "default", Component: FieldsComponent_1.TextField, type: "text", "data-cy": "settingDefault" },
    {
        field: "layout",
        Component: FieldsComponent_1.SelectField,
        options: [
            { label: "Default", value: "default" },
            { label: "Narrow", value: "narrow" },
            { label: "Wide", value: "wide" },
            { label: "Full", value: "full" },
        ],
    },
    { field: "alignment", Component: FieldsComponent_1.TextField, type: "text" },
    { field: "debounce", Component: FieldsComponent_1.CheckboxField },
    { field: "disabled", Component: FieldsComponent_1.CheckboxField },
    { field: "readonly", Component: FieldsComponent_1.CheckboxField },
    { field: "metadata", Component: FieldsComponent_1.TextField, type: "text" },
    {
        field: "conditions",
        Component: FieldsComponent_1.TextAreaField,
        inputClassName: AppEditor_module_css_1.default["settings-textarea"],
    },
];
exports.numberSettingConfig = [
    { field: "minValue", Component: FieldsComponent_1.TextField, type: "number", "data-cy": "minValueField" },
    { field: "maxValue", Component: FieldsComponent_1.TextField, type: "number", "data-cy": "maxValueField" },
    { field: "step", Component: FieldsComponent_1.TextField, type: "number", "data-cy": "stepValueField" },
];
exports.decimalSettingConfig = [
    { field: "decimals", Component: FieldsComponent_1.TextField, type: "number", "data-cy": "decimalsField" },
];
exports.numberRangeSettingConfig = [
    { field: "showInputField", Component: FieldsComponent_1.CheckboxField, "data-cy": "showInputField" },
];
exports.textSettingConfig = [
    { field: "cols", Component: FieldsComponent_1.TextField, type: "number", "data-cy": "colsField" },
    { field: "rows", Component: FieldsComponent_1.TextField, type: "number", "data-cy": "rowsField" },
];
exports.colorSettingConfig = [
    {
        field: "default",
        Component: FieldsComponent_1.ColorField,
        "data-cy": "colorDefaultValue"
    },
    {
        field: "placement",
        Component: FieldsComponent_1.SelectField,
        options: [
            { label: "Auto", value: "auto" },
            { label: "Top", value: "top" },
            { label: "Left", value: "left" },
            { label: "Right", value: "right" },
            { label: "Bottom", value: "bottom" }
        ],
        "data-cy": "placementField"
    },
    {
        field: "hideColorPalette",
        Component: FieldsComponent_1.CheckboxField,
        "data-cy": "hideColorPaletteField"
    },
    {
        field: "hideAlpha",
        Component: FieldsComponent_1.CheckboxField,
        "data-cy": "hideAlphaField"
    }
];
exports.advancedSelectConfig = [
    {
        field: "default",
        Component: FieldsComponent_1.AdvancedSelectField,
        "data-cy": "advancedSelectDefaultField"
    },
    {
        field: "placeholder",
        Component: FieldsComponent_1.TextField,
        type: "text",
        "data-cy": "advancedSelectPlaceholderField"
    },
    {
        field: "no_option_text",
        Component: FieldsComponent_1.TextField,
        type: "text",
        "data-cy": "advancedSelectNoOptionTextField"
    },
    {
        field: "value_property",
        Component: FieldsComponent_1.TextField,
        type: "text",
        "data-cy": "advancedSelectValuePropertyField"
    },
    {
        field: "label_property",
        Component: FieldsComponent_1.TextField,
        type: "text",
        "data-cy": "advancedSelectLabelPropertyField"
    },
    {
        field: "options",
        Component: FieldsComponent_1.TextAreaField,
        inputClassName: AppEditor_module_css_1.default["settings-textarea"],
        "data-cy": "advancedSelectOptionsField"
    },
    {
        field: "url",
        Component: FieldsComponent_1.TextField,
        type: "text",
        "data-cy": "advancedSelectUrlField"
    },
    {
        field: "search_param",
        Component: FieldsComponent_1.TextField,
        type: "text",
        "data-cy": "advancedSelectSearchParamField"
    },
    {
        field: "response_data",
        Component: FieldsComponent_1.TextField,
        type: "text",
        "data-cy": "advancedSelectResponseDataField"
    },
    {
        field: "should_fetch_on_load",
        Component: FieldsComponent_1.CheckboxField,
        "data-cy": "advancedSelectShouldFetchOnLoadField"
    },
    {
        field: "should_throttle_request",
        Component: FieldsComponent_1.CheckboxField,
        "data-cy": "advancedSelectShouldThrottleRequestField"
    },
    {
        field: "should_use_local_filter",
        Component: FieldsComponent_1.CheckboxField,
        "data-cy": "advancedSelectShouldUseLocalFilterField"
    }
];
exports.mediaLibrarySettingConfig = [
    {
        field: "mime_group",
        Component: FieldsComponent_1.TextField,
        type: "text",
        "data-cy": "mimeGroupField"
    },
    {
        field: "origin",
        Component: FieldsComponent_1.TextField,
        type: "text",
        "data-cy": "originField"
    }
];
